import { createSelector } from 'reselect';
import { RootState } from '../../store/store';

const platformSuperAdminState = (state: RootState) => state.platformSuperAdmin;

const isPlatformSuperAdmin = createSelector(platformSuperAdminState, (s) => s.isPlatformSuperAdmin);
const accessChecked = createSelector(platformSuperAdminState, (s) => s.accessChecked);
const rows = createSelector(platformSuperAdminState, (s) => s.rows);
const me = createSelector(platformSuperAdminState, (s) => s.me);
const lastError = createSelector(platformSuperAdminState, (s) => s.lastError);
const usePlatformAudit = createSelector(platformSuperAdminState, (s) => s.usePlatformAudit);
const activeTenantId = createSelector(platformSuperAdminState, (s) => s.activeTenantId);

export const platformSuperAdminSelectors = {
    isPlatformSuperAdmin,
    accessChecked,
    rows,
    me,
    lastError,
    usePlatformAudit,
    activeTenantId
};
